import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { UserProvider } from './context/UserContext';
import { ThemeProvider } from './context/ThemeContext';
import { GlobalFontSizeProvider } from './context/GlobalFontSizeContext';
import { TutorialProvider } from './context/TutorialContext';
import './index.css';

// Initialize i18n - must be imported before App
import './i18n';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <GlobalFontSizeProvider>
          <ThemeProvider>
            <UserProvider>
              <TutorialProvider>
                <App />
              </TutorialProvider>
            </UserProvider>
          </ThemeProvider>
        </GlobalFontSizeProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
